import { JetView } from "webix-jet";

export default class AddNewMenuView extends JetView {
	config() {
		const _ = this.app.getService("locale")._;
		this.WithRoles = this.app.config.roles;

		let menuItems = [
			{
				id: "user",
				value: _("Add new user"),
			},
		];

		if (this.WithRoles)
			menuItems.push({
				id: "role",
				value: _("Add new role"),
			});

		return {
			view: "popup",
			width: 176,
			padding: 0,
			point: 0,
			borderless: true,
			css: "webix_um_add_new_menu",
			body: {
				view: "menu",
				autoheight: true,
				layout: "y",
				data: menuItems,
				on: {
					onMenuItemClick: id => {
						this.AddNew(id);
						this.getRoot().hide();
					},
				},
			},
		};
	}

	AddNew(id) {
		const _ = this.app.getService("locale")._;
		const prompt = this.app.getService("prompt");
		if (id == "role") {
			prompt
				.show(_("Enter role name"))
				.then(name => this.app.getService("operations").addRole({ name }))
				.then(data => this.ShowDetails("roles", data.id));
		} else if (id == "user") {
			prompt
				.show(_("Enter user name"))
				.then(name => {
					return this.app.getService("operations").addUser({ name });
				})
				.then(data => this.ShowDetails("users", data.id));
		}
	}
	ShowDetails(collection, id) {
		this.app.callEvent("details:item-click", [collection, id]);
	}
	Show(target) {
		this.getRoot().show(target, { x: 2 });
	}
}
